import { useEffect } from 'react';

export default function MapNotification({ notification, onDismiss }) {
  const { id, message, variant } = notification;
  const persistent = variant === 'error' || variant === 'warning';
  useEffect(() => {
    if (persistent) return undefined;
    const timer = setTimeout(() => onDismiss(id), 5000);
    return () => clearTimeout(timer);
  }, [id, persistent, onDismiss]);
  return (
    <div className={`mind-map-notification mind-map-notification--${variant}`}>
      <span role={variant === 'error' ? 'alert' : 'status'} aria-atomic="true">{message}</span>
      <button type="button" className="mind-map-notification__dismiss" aria-label={`Dismiss: ${message}`}
        onClick={() => onDismiss(id, true)}>×</button>
    </div>
  );
}
